import { makeStyles } from "tss-react/mui";

interface IStyleParams {
    isMobile: boolean;
    isTablet: boolean;
    isMobileOrTablet: boolean;
}

export const useStyle = makeStyles<IStyleParams>()((theme, { isMobile, isMobileOrTablet, isTablet }) => ({
    container: {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: isMobile ? "center" : "flex-start",
        maxWidth: 1280,
        width: "100%",
        padding: isMobile ? theme.spacing(7, 4) : theme.spacing(0, 1.275),
        gap: theme.spacing(6),
        boxSizing: "border-box",
    },
    sectionTitle: {
        color: theme.palette.secondary.main,
        textAlign: isMobile ? "center" : "left",
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: isMobile ? "center" : "flex-start",
        gap: theme.spacing(3),
        width: isMobileOrTablet ? "100%" : 729,
        maxWidth: isMobile ? 600 : undefined,
        paddingBlock: isTablet ? theme.spacing(4) : 0,
        paddingRight: isTablet ? theme.spacing(4) : 0,
    },
    illustration: {
        flexShrink: 0,
        maxWidth: 450,
        width: "100%",
        objectFit: "cover",
        borderRadius: theme.shape.borderRadius,
    },
    cardsGrid: {
        display: "grid",
        gridTemplateColumns: isMobileOrTablet ? "1fr" : "1fr 1fr",
        gap: theme.spacing(2),
        width: "100%",
    },
    card: {
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[2],
        maxWidth: isMobileOrTablet ? "100%" : 356,
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(1),
        textAlign: "center",
        padding: theme.spacing(3, 2),
    },
    cardTitle: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightRegular,
    },
    cardDescription: {
        color: theme.palette.secondary.main,
        overflowWrap: "break-word",
        width: isMobile ? 260 : 311,
    },
}));
